import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ClapColoredSvg } from './assets/clap-colored.svg';

const ClapColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={ClapColoredSvg} ref={ref} {...args} />);

export default ClapColoredIcon;
